module.exports = __webpack_public_path__ + "static/img/lmp_logo@3x.15dc96f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/3x/lmp_logo@3x.png
// module id = s8rT
// module chunks = 1